// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { GiftingProposalProjectionFragment } from '../../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import { gql } from '@apollo/client';
import { GiftingProposalProjectionFragmentDoc } from '../../../../modules/gifting/proposal/graphql/GiftingProposalProjection.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateGiftProposalMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateProposalInput;
}>;


export type CreateGiftProposalMutation = { __typename?: 'Mutation', createProposalV2: { __typename?: 'Proposal', id: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string, giftingScenarios?: Array<{ __typename?: 'GiftingProposalScenario', id: string, projections: (
          { __typename?: 'GiftingProposalProjections' }
          & GiftingProposalProjectionFragment
        ) }> | null } | null } };

export const Operations = {
  Mutation: {
    CreateGiftProposal: 'CreateGiftProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateGiftProposalDocument = gql`
    mutation CreateGiftProposal($input: AugmentedCreateProposalInput!) {
  createProposalV2(input: $input) {
    id
    giftingProposal {
      id
      giftingScenarios {
        id
        projections {
          ...GiftingProposalProjection
        }
      }
    }
  }
}
    ${GiftingProposalProjectionFragmentDoc}`;
export type CreateGiftProposalMutationFn = Apollo.MutationFunction<CreateGiftProposalMutation, CreateGiftProposalMutationVariables>;

/**
 * __useCreateGiftProposalMutation__
 *
 * To run a mutation, you first call `useCreateGiftProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftProposalMutation, { data, loading, error }] = useCreateGiftProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftProposalMutation, CreateGiftProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftProposalMutation, CreateGiftProposalMutationVariables>(CreateGiftProposalDocument, options);
      }
export type CreateGiftProposalMutationHookResult = ReturnType<typeof useCreateGiftProposalMutation>;
export type CreateGiftProposalMutationResult = Apollo.MutationResult<CreateGiftProposalMutation>;
export type CreateGiftProposalMutationOptions = Apollo.BaseMutationOptions<CreateGiftProposalMutation, CreateGiftProposalMutationVariables>;